import React from 'react';

export default function EmailIcon(props) {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V12C20 14.2091 18.2091 16 16 16H4C1.79086 16 0 14.2091 0 12V4ZM3.91595 2.00173L10 8.08579L16.0841 2.00173C16.0562 2.00058 16.0282 2 16 2H4C3.97184 2 3.94382 2.00058 3.91595 2.00173ZM2.20426 3.11847C2.07346 3.3844 2 3.68362 2 4V12C2 13.1046 2.89543 14 4 14H16C17.1046 14 18 13.1046 18 12V4C18 3.68362 17.9265 3.3844 17.7957 3.11847L10.7071 10.2071C10.3166 10.5976 9.68342 10.5976 9.29289 10.2071L2.20426 3.11847Z" fill="#111" />
    </svg>
  );
}
